import { getDate } from '../../office-lab/assets/utils';
export const BOT_VISIBLE_COLUMNS = ['username', 'description', 'requester', 'ownerGroup', 'createdAt', 'lastUpdatedAt'];
export const SORTED_FILED = {
    id: 'createdAt',
    header: 'Created at',
    cell: (e) => getDate(e.createdAt),
    sortingField: 'createdAt',
    width: 250,
};
export const BOT_COLUMNS_DEFINITION = [
    {
        id: 'username',
        header: 'Bot account username',
        cell: (e) => e.username,
        width: 250,
    },
    {
        id: 'description',
        header: 'Description',
        cell: (e) => e.description,
        width: 250,
    },
    {
        id: 'requester',
        header: 'Requester',
        cell: (e) => e.requester,
        width: 250,
    },
    {
        id: 'ownerGroup',
        header: 'Owner group',
        cell: (e) => e.ownerGroup,
        width: 250,
    },
    SORTED_FILED,
    {
        id: 'lastUpdatedAt',
        header: 'Last updated at',
        cell: (e) => getDate(e.lastUpdatedAt),
        width: 250,
    },
];
export const COLLECTION_PREFERENCES_PROPS = {
    pageSizePreference: {
        title: 'Select page size',
        options: [
            { value: 20, label: '20 bots' },
            { value: 50, label: '50 bots' },
            { value: 100, label: '100 bots' },
        ],
    },
    visibleContentPreference: {
        title: 'Select visible columns',
        options: [
            {
                label: 'Main properties',
                options: BOT_COLUMNS_DEFINITION.map(({ id, header }) => ({
                    id,
                    label: header,
                    editable: id !== 'username',
                })),
            },
        ],
    },
    cancelLabel: 'Cancel',
    confirmLabel: 'Confirm',
    title: 'Preferences',
    stickyColumnsPreference: {
        firstColumns: {
            title: 'Freeze first column(s)',
            description: 'Keep the first column(s) visible while horizontally scrolling the table content.',
            options: [
                { label: 'None', value: 0 },
                { label: 'First column', value: 1 },
            ],
        },
    },
};
